import store from '@/store'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => store.getters['auth/isLoggedIn']

export const getUserData = () => store.state.auth.user

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  switch (userRole) {
    case 'superadmin':
    case 'admin':
    case 'user':
      return { name: 'not-authorized' }
    default:
      return { name: 'auth-login' }
  }
}

export const getTokenRaces = () => store.state.races

// Beta access gate: a shared password unlocks the CMS before login. CMS-namespaced
// cookie key so it never clashes with the website's own `isAuthorized` cookie.
export const AUTHORIZE_COOKIE = 'staketoken-cms:authorized'
export const AUTHORIZE_KEY = 'Racing321!!!'

export const isSiteAuthorized = () =>
  document.cookie
    .split('; ')
    .some(row => row === `${AUTHORIZE_COOKIE}=true`)

export const setSiteAuthorized = () => {
  const maxAge = 60 * 60 * 24 * 30 // 30 days
  document.cookie = `${AUTHORIZE_COOKIE}=true; path=/; max-age=${maxAge}`
}
